// extracted by mini-css-extract-plugin
export default {"section-header":"SectionHeader_section-header__I4bR0"};